import { render } from "./mpList.vue?vue&type=template&id=08dcd737&scoped=true"
import script from "./mpList.vue?vue&type=script&lang=js"
export * from "./mpList.vue?vue&type=script&lang=js"

import "./mpList.vue?vue&type=style&index=0&id=08dcd737&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08dcd737"]])

export default __exports__